import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { ArrowRight } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import AuthShell, { AuthLabel, AuthInput, AuthPrimaryButton, AuthErrorLine, GoogleSignInButton, formatApiErrorDetail } from "../components/AuthShell";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useAuth();

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      const { data } = await axios.post(`${API}/auth/login`, { email, password }, { withCredentials: true });
      setUser(data);
      // If the user came from the cart, hop back to Home so CartContext re-opens it.
      const fromCart = typeof window !== "undefined" && sessionStorage.getItem("wiu_reopen_cart") === "1";
      const dest = fromCart ? "/" : (location.state?.from || "/account");
      navigate(dest);
    } catch (err) {
      setError(formatApiErrorDetail(err?.response?.data?.detail) || "Login failed");
    } finally { setLoading(false); }
  };

  return (
    <AuthShell
      eyebrow="CUSTOMER · SIGN IN"
      title="Welcome back."
      subtitle="Track orders, redeem rewards, and share reviews from your Whip It Up account."
      footer={
        <>
          <p className="font-mono text-[10px] tracking-[0.3em] text-off-white/60">
            NEW HERE? <Link to="/register" className="text-rose hover:text-off-white" data-testid="link-register">CREATE ACCOUNT →</Link>
          </p>
          <p className="font-mono text-[10px] tracking-[0.3em] text-off-white/40">
            <Link to="/forgot-password" className="hover:text-rose" data-testid="link-forgot">FORGOT PASSWORD?</Link>
          </p>
        </>
      }
    >
      <form onSubmit={submit} className="mt-10 space-y-4" data-testid="login-form">
        <div>
          <AuthLabel>EMAIL</AuthLabel>
          <AuthInput type="email" value={email} onChange={(e) => setEmail(e.target.value)} autoFocus required data-testid="login-email-input" />
        </div>
        <div>
          <AuthLabel>PASSWORD</AuthLabel>
          <AuthInput type="password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="login-password-input" />
        </div>
        <AuthErrorLine error={error} />
        <AuthPrimaryButton type="submit" loading={loading} disabled={!email || !password} data-testid="login-submit-btn">
          SIGN IN <ArrowRight size={16} />
        </AuthPrimaryButton>
        <div className="flex items-center gap-3 my-2 text-off-white/30">
          <div className="flex-1 h-px bg-off-white/10" />
          <span className="font-mono text-[10px] tracking-[0.25em]">OR</span>
          <div className="flex-1 h-px bg-off-white/10" />
        </div>
        <GoogleSignInButton />
      </form>
    </AuthShell>
  );
};

export default Login;
